import { render, staticRenderFns } from "./MoneyCol.vue?vue&type=template&id=3fcae2c8&scoped=true"
import script from "./MoneyCol.vue?vue&type=script&lang=js"
export * from "./MoneyCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3fcae2c8",
  null
  
)

export default component.exports